import styled from 'styled-components';
import colors from 'Styles/colors';

const statusColors = {
  'new': colors.blueCerulean,
  'open': colors.warmPurple,
  're-opened': colors.tangerine,
  'risk-accepted': colors.apple,
  'closed': colors.blueGrey
};

export const Wrapper = styled.div`
  display: flex;
  & >:first-child {
    border-radius: 4px 0 0 4px;
  }
  & >:last-child {
    border-radius: 0 4px 4px 0;
  }
`;
Wrapper.displayName = 'Wrapper';

export const Item = styled.div`
  background-color: ${({ status }) => statusColors[status]};
  width: 20px;
  height: 20px;
  cursor: pointer;
  ${({ singleItem }) => singleItem && `
    border-radius: 4px !important;
  `}
`;
Item.displayName = 'Item';
